// Centralized API configuration
// This ensures consistent API URL handling across the app

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!BACKEND_URL) {
  console.error('⚠️ REACT_APP_BACKEND_URL is not set!');
  console.error('Please set REACT_APP_BACKEND_URL in your environment variables.');
  console.error('For Railway deployment, add it in the Variables tab of your frontend service.');
}

export const API_BASE_URL = BACKEND_URL || '';
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

// Log the API URL in development for debugging
if (process.env.NODE_ENV === 'development') {
  console.log('API Base URL:', API_BASE_URL);
  console.log('API Endpoint:', API);
}

/**
 * Converts a relative URL (like /api/uploads/file.jpg) to an absolute URL
 * pointing to the backend server. If the URL is already absolute, returns it as-is.
 * 
 * @param {string} url - The URL to convert (can be relative or absolute)
 * @returns {string} - Absolute URL pointing to the backend
 */
export function getImageUrl(url) {
  if (!url) return '';
  
  // If it's already an absolute URL (starts with http:// or https://), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's a relative URL (starts with /), prepend the backend URL
  if (url.startsWith('/')) {
    return BACKEND_URL ? `${BACKEND_URL}${url}` : url;
  }
  
  // If it doesn't start with /, assume it's a relative path and prepend /api/uploads/
  // This handles cases where just the filename is stored
  return BACKEND_URL ? `${BACKEND_URL}/api/uploads/${url}` : `/api/uploads/${url}`;
}

